<div class="component-container" fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" class="content-container" fxLayoutAlign="center center" fxLayoutGap="40px">
    <div fxLayout="column" fxLayoutAlign="center center">
      <h1 [innerHTML]="title | translate | sanitizeHtml" class="title-page-policy"></h1>

      <div fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center center">
        <p class="title-claim-text500" *ngIf="!isOtherPurpose">
          {{ (isClaim ? 'keywords.claims_module.your_claim_id' : 'keywords.quotes_module.your_policy_number') | translate }}:
          {{ yourID }}.
        </p>
        <p class="text-gray-desc description">{{ description | translate }}</p>
      </div>
    </div>

    <button mat-button class="medium-button-blue" (click)="goToDashboard()">
      {{ 'keywords.backToHome' | translate }}
    </button>
  </div>
</div>
